module.exports = __webpack_public_path__ + "img/new-barcode-icon.40a5da04.svg";